"use client";

import { c as _c } from "react/compiler-runtime";
import { LinkIcon } from "@heroicons/react/24/solid";
import { Button, handleCopyClipboard } from "@saridana-core/react-ui-kit";
import { CareerDetailPageData } from "@shared/types";
import { ButtonLink } from "@shared/ui";
import { FacebookIcon, LinkedinIcon, PinLocationIcon, WhatsappIcon, XIcon } from "@shared/ui/custom-icon";
import { getTimeAgo } from "@shared/utils/time-ago";
import { FacebookShareButton, LinkedinShareButton, TwitterShareButton, WhatsappShareButton } from "react-share";
export function CareerHeroSection(t0) {
  const $ = _c(47);
  const {
    attributes: t1
  } = t0;
  const {
    title,
    location,
    type,
    buttons,
    sharedLink,
    publishedDate
  } = t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      background: "linear-gradient(264.23deg, #134E67 4.59%, #1DB0DE 80.88%)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== title) {
    t3 = <h1 className="text-center text-white font-bold text-5xl sm:text-7xl lg:text-5xl mb-4">{title}</h1>;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <PinLocationIcon className="text-white size-5 sm:size-6" />;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== location) {
    t5 = <div className="flex items-center space-x-1">{t4}<span>{location}</span></div>;
    $[4] = location;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span> •</span>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== type) {
    t7 = <span>{type}</span>;
    $[7] = type;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span> •</span>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== publishedDate) {
    t9 = publishedDate && <span>{getTimeAgo(publishedDate)}</span>;
    $[10] = publishedDate;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t5 || $[13] !== t7 || $[14] !== t9) {
    t10 = <div className="text-white text-lg sm:text-xl flex items-center justify-center space-x-2 mb-8">{t5}{t6}{t7}{t8}{t9}</div>;
    $[12] = t5;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== buttons) {
    t11 = buttons && buttons?.length > 0 && <div className="flex justify-center space-x-3 mx-auto mb-8">{buttons?.map(_temp)}</div>;
    $[16] = buttons;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="text-white text-lg font-semibold">Bagikan:</div>;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const t13 = sharedLink || "";
  let t14;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <WhatsappIcon className="size-6 text-white" />;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] !== t13) {
    t15 = <WhatsappShareButton url={t13}>{t14}</WhatsappShareButton>;
    $[20] = t13;
    $[21] = t15;
  } else {
    t15 = $[21];
  }
  const t16 = sharedLink || "";
  let t17;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <LinkedinIcon className="size-6 text-white" />;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t16) {
    t18 = <LinkedinShareButton url={t16}>{t17}</LinkedinShareButton>;
    $[23] = t16;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  const t19 = sharedLink || "";
  let t20;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <XIcon className="size-6 text-white" />;
    $[25] = t20;
  } else {
    t20 = $[25];
  }
  let t21;
  if ($[26] !== t19) {
    t21 = <TwitterShareButton url={t19}>{t20}</TwitterShareButton>;
    $[26] = t19;
    $[27] = t21;
  } else {
    t21 = $[27];
  }
  const t22 = sharedLink || "";
  let t23;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <FacebookIcon className="size-6 text-white" />;
    $[28] = t23;
  } else {
    t23 = $[28];
  }
  let t24;
  if ($[29] !== t22) {
    t24 = <FacebookShareButton url={t22}>{t23}</FacebookShareButton>;
    $[29] = t22;
    $[30] = t24;
  } else {
    t24 = $[30];
  }
  let t25;
  if ($[31] !== sharedLink) {
    t25 = () => handleCopyClipboard(sharedLink || "");
    $[31] = sharedLink;
    $[32] = t25;
  } else {
    t25 = $[32];
  }
  let t26;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <LinkIcon className="size-6 text-white" />;
    $[33] = t26;
  } else {
    t26 = $[33];
  }
  let t27;
  if ($[34] !== t25) {
    t27 = <Button size="icon" variant="ghost" className="size-6 !bg-transparent" onClick={t25}>{t26}</Button>;
    $[34] = t25;
    $[35] = t27;
  } else {
    t27 = $[35];
  }
  let t28;
  if ($[36] !== t15 || $[37] !== t18 || $[38] !== t21 || $[39] !== t24 || $[40] !== t27) {
    t28 = <div className="flex gap-4 items-center justify-center">{t12}<div className="flex items-center gap-3">{t15}{t18}{t21}{t24}{t27}</div></div>;
    $[36] = t15;
    $[37] = t18;
    $[38] = t21;
    $[39] = t24;
    $[40] = t27;
    $[41] = t28;
  } else {
    t28 = $[41];
  }
  let t29;
  if ($[42] !== t10 || $[43] !== t11 || $[44] !== t28 || $[45] !== t3) {
    t29 = <section><div style={t2}><div className="container relative lg:max-w-2xl mx-auto pt-20 sm:pt-[100px] lg:pt-24 pb-10 sm:pb-[60px] lg:pb-12">{t3}{t10}{t11}{t28}</div></div></section>;
    $[42] = t10;
    $[43] = t11;
    $[44] = t28;
    $[45] = t3;
    $[46] = t29;
  } else {
    t29 = $[46];
  }
  return t29;
}
function _temp(button, index) {
  return <ButtonLink key={"career-hero-button-" + index} {...button} variant="default" />;
}